<template>
  <div class="exam-log-page">
    <baseBack />

    <div class="content">
      <!-- 表格绑定兼容处理后的 tableList -->
      <el-table :data="tableList" style="width: 100%" max-height="600" border v-loading="loading" class="custom-table">
        <el-table-column prop="carType" label="驾照类型" min-width="100">
          <template slot-scope="scope">
            {{ $CarType(scope.row.carType) }}
          </template>
        </el-table-column>

        <el-table-column prop="subject" label="科目" min-width="100">
          <template slot-scope="scope">
            {{ $SubjectType(scope.row.subject) }}
          </template>
        </el-table-column>

        <el-table-column prop="testPaperName" label="试题名称" min-width="180"></el-table-column>
        <el-table-column prop="useTimeStr" label="答题用时(分钟)" min-width="120"></el-table-column>

        <el-table-column prop="grade" label="得分" min-width="100">
          <template slot-scope="scope">
            <span class="score-text">{{ scope.row.grade }}分</span>
          </template>
        </el-table-column>

        <el-table-column prop="totalNum" label="答题数量" min-width="100"></el-table-column>
        <el-table-column prop="createTime" label="模拟时间" min-width="180"></el-table-column>

        <el-table-column label="操作" min-width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="flow(scope.row)">错题练习</el-button>
            <el-button size="mini" type="danger" v-if="status" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页与操作区 -->
      <div class="pagination-box">
        <basePagination :size="list.perPage" :page="list.currentPage" :total="list.total" @SizeChange="SizeChange"
          @CurrentChange="CurrentChange" />
        <el-button type="primary" size="mini" :disabled="list.total === 0" @click="allDel" class="del-all-btn">
          全部删除
        </el-button>
      </div>
    </div>

    <!-- 确认删除弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :show-close="false" :close-on-click-modal="false">
      <span>确定要全部删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAllDel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import loader from '@/components/base/basePagination/controls.js'

  export default {
    mixins: [loader],
    data() {
      return {
        dialogVisible: false,
        initial: {
          geturl: '/user/examLog',
          params: {}
        },
        // 分页数据独立维护
        list: {
          total: 0,
          perPage: 10,
          currentPage: 1
        },
        // 兼容不同环境数据结构的表格数据
        tableList: [],
        loading: true,
        status: ''
      }
    },
    created() {
      if (this.$route.query.status) {
        this.status = this.$route.query.status
      }
      this.jiazai()
    },
    methods: {
      confirmAllDel() {
        this.axios.post('/user/clearLog', {
            id: 0,
            type: 1
          })
          .then(() => {
            this.jiazai()
            this.dialogVisible = false
          })
          .catch(error => console.error('全部删除失败:', error))
      },
      allDel() {
        this.dialogVisible = true
      },
      del(e) {
        this.axios.post('/user/clearLog', {
            id: e.id,
            type: 1
          })
          .then(() => this.jiazai())
          .catch(error => console.error('删除失败:', error))
      },
      flow(e) {
        if (!this.status) {
          this.$Go('case', {
            txt: '模拟考试',
            car: this.$CarType(e.carType),
            carId: e.carType,
            subject: this.$SubjectType(e.subject),
            subjectId: e.subject
          })
        } else {
          if (e.mistakeNum <= 0) {
            this.$message({
              type: 'success',
              message: '暂无错题!'
            })
            return
          }
          this.$Go('case', {
            txt: '错题库',
            id: e.id
          })
        }
      },
      jiazai() {
        this.loading = true
        this.getData(this.initial.params)
          .then(res => {
            // 【核心兼容处理】：自适应获取真实数据
            // 如果 res 本身有 data 属性且是数组，说明是原始响应，取 res.data
            // 否则（比如电脑端拦截器已经解包），直接把 res 当作数据数组
            let realData = []
            if (res && Array.isArray(res.data)) {
              realData = res.data
            } else if (Array.isArray(res)) {
              realData = res
            }

            // 延迟赋值，给平板渲染引擎留出重绘时间
            setTimeout(() => {
              this.tableList = realData
            }, 50)

            // 更新分页信息
            this.list.total = res.total || 0
            this.list.perPage = res.perPage || 10
            this.list.currentPage = res.currentPage || 1
          })
          .catch(err => {
            console.error('数据加载失败:', err)
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>

<style scoped>
  .exam-log-page {
    width: 100%;
  }

  .content {
    width: 1200px;
    margin: 20px auto 0;
  }

  /* 表格样式优化 */
  .custom-table {
    border-radius: 4px;
    overflow: hidden;
  }

  ::v-deep .el-table th {
    background-color: #f5f7fa;
    color: #333;
    font-weight: bold;
  }

  ::v-deep .el-table .cell {
    padding-left: 10px;
    padding-right: 10px;
    text-align: center;
    line-height: 1.5;
  }

  .score-text {
    color: #409eff;
    font-weight: bold;
  }

  /* 分页区域样式 */
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 20px 0;
  }

  .del-all-btn {
    margin-left: 10px;
  }

  /* 平板/移动端响应式适配 */
  @media screen and (max-width: 768px) {
    .content {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
    }

    /* 平板上隐藏部分次要列，保证核心内容不被过度挤压 */
    ::v-deep .el-table-column[label="答题数量"] {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/recode/index.vue